import withNavigate from "../../../routes/withNavigate";
import GalleryFolderMasterContainer from "./GalleryFolderMasterContainer.jsx";

export default withNavigate(GalleryFolderMasterContainer);
